import { PREFIXES, toLanguageCode } from '#src/lib/i18n.ts';

const normalizePath = (pathname: string) =>
  pathname.toLowerCase().replace(/\/+$/, '') || '/';

/** English lives on the unprefixed URL. */
export const getLocalizedUrl = (
  origin: string,
  prefix: string | undefined,
  pathname: string
) => {
  const path = normalizePath(pathname);
  if (!prefix || prefix === '/en') {
    return `${origin}${path}`;
  }
  return `${origin}${prefix}${path === '/' ? '' : path}`;
};

/** `languages` restricts the list; with none, x-default goes too. */
export const getHrefLangUrls = (
  origin: string,
  pathname: string,
  languages?: readonly string[]
) => {
  const alternates = Object.entries(PREFIXES)
    .map(([prefix, locale]) => ({
      hrefLang: toLanguageCode(locale),
      href: getLocalizedUrl(origin, prefix, pathname),
    }))
    .filter(({ hrefLang }) => !languages || languages.includes(hrefLang));
  if (!alternates.length) return [];
  return [
    ...alternates,
    {
      hrefLang: 'x-default',
      href: getLocalizedUrl(origin, undefined, pathname),
    },
  ];
};
